(function () {
  var config = window.KKHeadlessCollection || {};
  var language = window.Theme && window.Theme.language ? window.Theme.language : {};
  var states = new WeakMap();
  var activeState = null;
  var apiReady = Boolean(config.enabled && config.storefrontToken && config.storeDomain);
  var RECYCLE_ICON = 'https://cdn.shopify.com/s/files/1/0561/7562/4355/files/RECYCLELOGO.png?v=1736935751';
  var MULTICOLOR_SWATCH_IMAGE = 'https://cdn.shopify.com/s/files/1/0561/7562/4355/files/multicolor.png?v=1779692182';
  var MULTICOLOR_SWATCH_STYLE = 'background: #fff url("' + MULTICOLOR_SWATCH_IMAGE + '") center/cover no-repeat;';
  var INDEX_VIEW = 'kk-index';
  var INDEX_CACHE_TTL = 10 * 60 * 1000;
  var EARLY_FILTER_RENDER_COUNT = 50;
  var INDEX_PARALLEL_BATCH = 12;
  var COLOR_SWATCH_STYLES = {
    beige: 'background: #d8c5a0;',
    black: 'background: #000;',
    bla: 'background: #006bdc;',
    blue: 'background: #006bdc;',
    bronze: 'background: #c47a32;',
    brons: 'background: #c47a32;',
    brun: 'background: #a8663d;',
    brown: 'background: #a8663d;',
    clear: 'background: #fff;',
    flerfargad: MULTICOLOR_SWATCH_STYLE,
    gold: 'background: #d9a300;',
    genomskinlig: 'background: #fff;',
    gra: 'background: #8f8f8f;',
    gray: 'background: #8f8f8f;',
    green: 'background: #08b84f;',
    grey: 'background: #8f8f8f;',
    gron: 'background: #08b84f;',
    guld: 'background: #d9a300;',
    gul: 'background: #ffe300;',
    harmaa: 'background: #8f8f8f;',
    hopea: 'background: #b8b8b8;',
    keltainen: 'background: #ffe300;',
    kirkas: 'background: #fff;',
    kulta: 'background: #d9a300;',
    lapinakyva: 'background: #fff;',
    lila: 'background: #a24bd7;',
    monivarinen: MULTICOLOR_SWATCH_STYLE,
    multicolor: MULTICOLOR_SWATCH_STYLE,
    multi: MULTICOLOR_SWATCH_STYLE,
    musta: 'background: #000;',
    orange: 'background: #ff8900;',
    oranssi: 'background: #ff8900;',
    pink: 'background: #ffc2d7;',
    pinkki: 'background: #ffc2d7;',
    pronssi: 'background: #c47a32;',
    punainen: 'background: #ff2525;',
    red: 'background: #ff2525;',
    rod: 'background: #ff2525;',
    rosa: 'background: #ffc2d7;',
    'rose gold': 'background: #b76e79;',
    rosegold: 'background: #b76e79;',
    roseguld: 'background: #b76e79;',
    ruskea: 'background: #a8663d;',
    ruusukulta: 'background: #b76e79;',
    silver: 'background: #b8b8b8;',
    sininen: 'background: #006bdc;',
    svart: 'background: #000;',
    transparent: 'background: #fff;',
    valkoinen: 'background: #fff;',
    vihrea: 'background: #08b84f;',
    violett: 'background: #a24bd7;',
    violetti: 'background: #a24bd7;',
    violet: 'background: #a24bd7;',
    vit: 'background: #fff;',
    white: 'background: #fff;',
    yellow: 'background: #ffe300;'
  };
  var COLOR_GROUPS = [
    {
      key: 'beige',
      labels: { fi: 'Beige', sv: 'Beige', en: 'Beige' },
      aliases: ['beige']
    },
    {
      key: 'gray',
      labels: { fi: 'Harmaa', sv: 'Gr\u00e5', en: 'Gray' },
      aliases: ['harmaa', 'harmaat', 'siniharmaa', 'gray', 'grey', 'gra', 'graa', 'blue gray', 'bluegray']
    },
    {
      key: 'silver',
      labels: { fi: 'Hopea', sv: 'Silver', en: 'Silver' },
      aliases: ['hopea', 'silver']
    },
    {
      key: 'yellow',
      labels: { fi: 'Keltainen', sv: 'Gul', en: 'Yellow' },
      aliases: ['keltainen', 'yellow', 'gul']
    },
    {
      key: 'gold',
      labels: { fi: 'Kulta', sv: 'Guld', en: 'Gold' },
      aliases: ['kulta', 'gold', 'guld', 'oro']
    },
    {
      key: 'transparent',
      labels: { fi: 'L\u00e4pin\u00e4kyv\u00e4', sv: 'Genomskinlig', en: 'Transparent' },
      aliases: ['lapinakyva', 'transparent', 'transparentti', 'clear', 'kirkas', 'genomskinlig']
    },
    {
      key: 'multicolor',
      labels: { fi: 'Moniv\u00e4rinen', sv: 'Flerf\u00e4rgad', en: 'Multicolor' },
      aliases: [
        'elain',
        'animal',
        'animal print',
        'geometrinen',
        'geometric',
        'monivarinen',
        'multicolor',
        'multi color',
        'multi',
        'flerfargad',
        'naamiointi',
        'camouflage',
        'camo',
        'raidallinen',
        'striped',
        'stripe',
        'raidat',
        'kuvio',
        'pattern',
        'print',
        'random',
        'sateenkaari',
        'rainbow',
        'tie dye',
        'tiedye',
        'marmori',
        'marble',
        'swirl',
        'splatter'
      ]
    },
    {
      key: 'black',
      labels: { fi: 'Musta', sv: 'Svart', en: 'Black' },
      aliases: ['musta', 'black', 'svart']
    },
    {
      key: 'orange',
      labels: { fi: 'Oranssi', sv: 'Orange', en: 'Orange' },
      aliases: ['oranssi', 'orange']
    },
    {
      key: 'pink',
      labels: { fi: 'Pinkki', sv: 'Rosa', en: 'Pink' },
      aliases: ['pinkki', 'pink', 'vaaleanpunainen', 'rosa', 'light pink', 'lightpink']
    },
    {
      key: 'bronze',
      labels: { fi: 'Pronssi', sv: 'Brons', en: 'Bronze' },
      aliases: ['pronssi', 'bronze', 'brons']
    },
    {
      key: 'red',
      labels: { fi: 'Punainen', sv: 'R\u00f6d', en: 'Red' },
      aliases: ['punainen', 'red', 'rod', 'punaviini', 'burgundy', 'wine red', 'winered']
    },
    {
      key: 'brown',
      labels: { fi: 'Ruskea', sv: 'Brun', en: 'Brown' },
      aliases: ['ruskea', 'brown', 'brun']
    },
    {
      key: 'rose_gold',
      labels: { fi: 'Ruusukulta', sv: 'Ros\u00e9guld', en: 'Rose gold' },
      aliases: ['ruusukulta', 'rose gold', 'rosegold', 'roseguld']
    },
    {
      key: 'blue',
      labels: { fi: 'Sininen', sv: 'Bl\u00e5', en: 'Blue' },
      aliases: ['sininen', 'siniharmaa', 'tummansininen', 'turkoosi', 'turquoise', 'turkos', 'blue', 'dark blue', 'darkblue', 'navy', 'bla', 'blue gray', 'bluegray']
    },
    {
      key: 'white',
      labels: { fi: 'Valkoinen', sv: 'Vit', en: 'White' },
      aliases: ['valkoinen', 'white', 'vit', 'glow']
    },
    {
      key: 'green',
      labels: { fi: 'Vihre\u00e4', sv: 'Gr\u00f6n', en: 'Green' },
      aliases: ['vihrea', 'green', 'gron']
    },
    {
      key: 'violet',
      labels: { fi: 'Violetti', sv: 'Lila', en: 'Violet' },
      aliases: ['violetti', 'violet', 'violett', 'purple', 'lila']
    }
  ];

  var gridLaunchCountdownStarted = false;
  var GRID_LAUNCH_OPEN_THRESHOLD_MS = 90 * 86400 * 1000;

  function padGridLaunchNumber(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function formatGridLaunchCountdown(diffMs, dayOne, dayMany) {
    var total = Math.max(0, Math.floor(diffMs / 1000));
    var days = Math.floor(total / 86400);
    var hours = Math.floor((total % 86400) / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    var seconds = total % 60;
    var time = padGridLaunchNumber(hours) + ':' + padGridLaunchNumber(minutes) + ':' + padGridLaunchNumber(seconds);
    var dayLabel = days === 1 ? (dayOne || 'päivä') : (dayMany || 'päivää');

    return days > 0 ? days + ' ' + dayLabel + ' ' + time : time;
  }

  function updateGridLaunchCountdowns() {
    document.querySelectorAll('[data-grid-launch-countdown]').forEach(function (countdown) {
      var target = parseInt(countdown.getAttribute('data-target'), 10);
      var timeEl = countdown.querySelector('[data-grid-launch-time]');
      var dayOne = countdown.getAttribute('data-day-one') || 'päivä';
      var dayMany = countdown.getAttribute('data-day-many') || 'päivää';
      var openText = countdown.getAttribute('data-open-text') || 'Ajankohta avoin';
      var diffMs;

      if (!isFinite(target)) {
        countdown.hidden = true;
        return;
      }

      diffMs = (target * 1000) - Date.now();

      if (diffMs <= 0) {
        countdown.hidden = true;
        countdown.setAttribute('aria-hidden', 'true');
        return;
      }

      countdown.hidden = false;
      countdown.setAttribute('aria-hidden', 'false');

      if (timeEl) {
        timeEl.textContent = diffMs > GRID_LAUNCH_OPEN_THRESHOLD_MS ?
          openText :
          formatGridLaunchCountdown(diffMs, dayOne, dayMany);
      }
    });
  }

  function initGridLaunchCountdowns() {
    updateGridLaunchCountdowns();

    if (gridLaunchCountdownStarted) {
      return;
    }

    gridLaunchCountdownStarted = true;
    window.setInterval(updateGridLaunchCountdowns, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGridLaunchCountdowns);
  } else {
    initGridLaunchCountdowns();
  }

  document.addEventListener('shopify:section:load', initGridLaunchCountdowns);

  if (!apiReady) {
    return;
  }

  function t(key, fallback) {
    return typeof language[key] === 'string' && language[key] !== '' ? language[key] : fallback;
  }

  function toNumber(value, fallback) {
    var parsed = parseFloat(String(value == null ? '' : value).replace(',', '.'));

    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function decodeBase64Url(value) {
    var normalized = String(value || '').replace(/-/g, '+').replace(/_/g, '/');

    while (normalized.length % 4) {
      normalized += '=';
    }

    try {
      return decodeURIComponent(Array.prototype.map.call(atob(normalized), function (character) {
        return '%' + ('00' + character.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    } catch (error) {
      return '';
    }
  }

  function encodeBase64Url(value) {
    try {
      return btoa(unescape(encodeURIComponent(value)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
    } catch (error) {
      return '';
    }
  }

  function stableFilterKey(input) {
    return JSON.stringify(input || {});
  }

  function parseFilterInput(value) {
    try {
      return JSON.parse(value || '{}');
    } catch (error) {
      return {};
    }
  }

  function getMoneyFormatter(currencyCode) {
    try {
      return new Intl.NumberFormat(config.moneyLocale || document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currencyCode || config.currencyCode || 'EUR'
      });
    } catch (error) {
      return null;
    }
  }

  function formatMoney(amount, currencyCode) {
    var formatter = getMoneyFormatter(currencyCode);
    var numeric = toNumber(amount, 0);

    return formatter ? formatter.format(numeric) : numeric.toFixed(2) + ' ' + (currencyCode || config.currencyCode || 'EUR');
  }

  function getCurrencySymbol(currencyCode) {
    var formatted = formatMoney(0, currencyCode || config.currencyCode);
    var symbol = formatted.replace(/[\d\s., ]/g, '').trim();

    return symbol || currencyCode || config.currencyCode || '';
  }

  function buildProductUrl(handle) {
    var root = config.rootUrl || (window.Theme && window.Theme.routes && window.Theme.routes.root_url) || '/';

    if (root.charAt(root.length - 1) !== '/') {
      root += '/';
    }

    return root + 'products/' + handle;
  }

  function getNativeIndexSort(sortBy) {
    return sortBy === 'manual' || sortBy === 'best-selling' ? sortBy : '';
  }

  function buildLiquidIndexUrl(handle, page, sortBy) {
    var params = new URLSearchParams();

    params.set('view', INDEX_VIEW);
    params.set('page', page);

    if (sortBy) {
      params.set('sort_by', sortBy);
    }

    return '/collections/' + encodeURIComponent(handle) + '?' + params.toString();
  }

  function fetchLiquidPage(state, page, retriesLeft) {
    if (retriesLeft === undefined) {
      retriesLeft = 3;
    }

    return fetch(buildLiquidIndexUrl(state.handle, page, state.indexSortBy || getNativeIndexSort(state.sortBy)), {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Index page ' + page + ' failed: ' + response.status);
      }
      return response.text();
    }).then(function (text) {
      return JSON.parse(text);
    }).catch(function (error) {
      if (retriesLeft > 0) {
        var delay = 400 * (4 - retriesLeft);
        return new Promise(function (resolve) {
          window.setTimeout(resolve, delay);
        }).then(function () {
          return fetchLiquidPage(state, page, retriesLeft - 1);
        });
      }
      throw error;
    });
  }

  function runInBatches(items, batchSize, worker) {
    var index = 0;

    function next() {
      var batch;

      if (index >= items.length) {
        return Promise.resolve();
      }

      batch = items.slice(index, index + batchSize);
      index += batchSize;

      return Promise.all(batch.map(worker)).then(next);
    }

    return next();
  }

  function metafieldFromLiquid(value) {
    if (value == null) {
      return null;
    }

    if (Array.isArray(value)) {
      return { value: JSON.stringify(value) };
    }

    return { value: String(value) };
  }

  function normalizeLiquidProduct(raw, currencyCode) {
    var currency = currencyCode || 'EUR';
    var priceMin = toNumber(raw.pmin, 0) / 100;
    var priceMax = toNumber(raw.pmax, raw.pmin) / 100;
    var compareMin = toNumber(raw.cmin, 0) / 100;
    var compareMax = toNumber(raw.cmax, raw.cmin) / 100;
    var compareAtRange = compareMin > priceMin ? {
      minVariantPrice: { amount: String(compareMin), currencyCode: currency },
      maxVariantPrice: { amount: String(compareMax || compareMin), currencyCode: currency }
    } : null;

    return {
      id: 'gid://shopify/Product/' + raw.i,
      legacyId: raw.i,
      sourceOrder: toNumber(raw.so, 0),
      handle: raw.h,
      title: raw.t,
      vendor: raw.v,
      tags: raw.tg || [],
      availableForSale: Boolean(raw.av),
      createdAt: raw.ca,
      createdAtTimestamp: toNumber(raw.cts, 0),
      priceRange: {
        minVariantPrice: { amount: String(priceMin), currencyCode: currency },
        maxVariantPrice: { amount: String(priceMax), currencyCode: currency }
      },
      compareAtPriceRange: compareAtRange,
      featuredImage: raw.img && raw.img.u ? { url: raw.img.u, altText: raw.img.a || '' } : null,
      muovi: metafieldFromLiquid(raw.mu),
      kunto: metafieldFromLiquid(raw.ku),
      colorPattern: metafieldFromLiquid(raw.co),
      profile: metafieldFromLiquid(raw.pr),
      nopeus: metafieldFromLiquid(raw.sp),
      liito: metafieldFromLiquid(raw.gl),
      vakaus: metafieldFromLiquid(raw.tu),
      feidi: metafieldFromLiquid(raw.fa),
      badgeText: raw.bt == null ? '' : String(raw.bt),
      badgeColor: raw.bc == null ? '' : String(raw.bc),
      judgeMeBadgeHtml: raw.jb == null ? '' : String(raw.jb),
      releaseTimestamp: toNumber(raw.rts, 0),
      releaseCountdownLabel: raw.rl == null ? '' : String(raw.rl),
      releaseCountdownDayOne: raw.rdo == null ? '' : String(raw.rdo),
      releaseCountdownDayMany: raw.rdm == null ? '' : String(raw.rdm),
      releaseCountdownOpenText: raw.rot == null ? '' : String(raw.rot)
    };
  }

  function appendLiquidProducts(state, products, payload) {
    var rawProducts;

    if (payload && payload.currency) {
      state.currencyCode = payload.currency;
    }

    rawProducts = (payload && payload.products) || [];
    rawProducts.forEach(function (raw) {
      products.push(normalizeLiquidProduct(raw, state.currencyCode));
    });

    renderIndexLoading(state, products.length);
    maybeRenderPartialIndex(state, products);
  }

  function maybeRenderPartialIndex(state, products) {
    if (state.indexLoaded || products.length < EARLY_FILTER_RENDER_COUNT) {
      return;
    }

    state.indexProducts = products.slice();
    state.root.classList.add('kk-headless-collection--partial-index');

    window.clearTimeout(state.partialRenderTimer);
    state.partialRenderTimer = window.setTimeout(function () {
      if (state.indexLoaded) return;
      buildFilters(state);

      if (state.partialRendered) {
        updateFilterCountsInPlace(state);
      } else {
        state.partialRendered = true;
        renderFilters(state);
      }
    }, state.partialRendered ? 500 : 0);
  }

  function updateFilterCountsInPlace(state) {
    var containers = [getSidebar(state)];
    var modalContent = document.querySelector('[data-modal-container] [data-modal-content]');
    if (modalContent) containers.push(modalContent);

    containers.forEach(function (container) {
      if (!container) return;

      var inputMap = {};
      container.querySelectorAll('[data-kk-headless-filter-input]').forEach(function (input) {
        inputMap[input.value] = {
          input: input,
          item: input.closest('.kk-facet__item')
        };
      });

      (state.filters || []).forEach(function (filter) {
        if (filter.type === 'PRICE_RANGE') return;

        (filter.values || []).forEach(function (value) {
          var entry = inputMap[value.input];
          if (!entry) return;

          var countEl = entry.item && entry.item.querySelector('.kk-facet__count');
          if (countEl && state.showProductCounts) {
            countEl.textContent = '(' + (value.count || 0) + ')';
          }

          var checked = entry.input.checked;
          var disabled = !checked && value.count === 0;
          entry.input.disabled = disabled;
          if (entry.item) {
            entry.item.classList.toggle('filter-item--disabled', disabled);
          }
        });
      });
    });
  }

  function defaultLabel(key, fallback) {
    var code = String(config.language || '').toLowerCase();
    var labels = {
      fi: {
        vendor: 'Merkki',
        profile: 'Profile'
      },
      sv: {
        vendor: 'Märke',
        profile: 'Profil'
      },
      en: {
        vendor: 'Brand',
        profile: 'Profile'
      }
    };

    return (labels[code] && labels[code][key]) || fallback;
  }

  function getFacetDefinitions() {
    return [
      {
        key: 'vendor',
        id: 'filter.p.vendor',
        label: t('filter_brand', defaultLabel('vendor', 'Brand')),
        values: function (product) {
          return product.vendor ? [product.vendor] : [];
        },
        input: function (value) {
          return { productVendor: value };
        }
      },
      {
        key: 'my_fields.muovi',
        id: 'filter.p.m.my_fields.muovi',
        label: t('disc_plastic', 'Plastic'),
        values: function (product) {
          return getMetafieldValues(product.muovi);
        },
        input: function (value) {
          return { productMetafield: { namespace: 'my_fields', key: 'muovi', value: value } };
        }
      },
      {
        key: 'custom.profile',
        id: 'filter.p.m.custom.profile',
        label: t('filter_profile', defaultLabel('profile', 'Profile')),
        values: function (product) {
          return getMetafieldValues(product.profile);
        },
        input: function (value) {
          return { productMetafield: { namespace: 'custom', key: 'profile', value: value } };
        }
      },
      {
        key: 'my_fields.kunto',
        id: 'filter.p.m.my_fields.kunto',
        label: t('disc_condition', 'Condition'),
        values: function (product) {
          return getMetafieldValues(product.kunto);
        },
        input: function (value) {
          return { productMetafield: { namespace: 'my_fields', key: 'kunto', value: value } };
        }
      },
      {
        key: 'shopify.color-pattern',
        id: 'filter.p.m.shopify.color-pattern',
        label: t('disc_color', 'Color'),
        swatch: true,
        values: function (product) {
          return getColorPatternValues(product);
        },
        input: function (value) {
          return { productMetafield: { namespace: 'shopify', key: 'color-pattern', value: value } };
        }
      },
      createDiscRangeDefinition('custom.nopeus', 'filter.p.m.custom.nopeus', t('flight_numbers_speed', 'Speed'), 'nopeus'),
      createDiscRangeDefinition('custom.liito', 'filter.p.m.custom.liito', t('flight_numbers_glide', 'Glide'), 'liito'),
      createDiscRangeDefinition('custom.vakaus', 'filter.p.m.custom.vakaus', t('flight_numbers_turn', 'Turn'), 'vakaus'),
      createDiscRangeDefinition('custom.feidi', 'filter.p.m.custom.feidi', t('flight_numbers_fade', 'Fade'), 'feidi')
    ];
  }

  function createDiscRangeDefinition(key, id, label, productKey) {
    var pieces = key.split('.');

    return {
      key: key,
      id: id,
      label: label,
      range: true,
      values: function (product) {
        return getMetafieldValues(product[productKey]);
      },
      input: function (value) {
        return { productMetafield: { namespace: pieces[0], key: pieces[1], value: String(value) } };
      }
    };
  }

  function getMetafieldValues(metafield) {
    var value = metafield && metafield.value;
    var parsed;

    if (value == null || value === '') {
      return [];
    }

    try {
      parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.map(String).filter(Boolean);
      }
      if (parsed != null && typeof parsed !== 'object') {
        return [String(parsed)];
      }
    } catch (error) {
      // Liquid returns single-line metafields as plain strings.
    }

    return [String(value)];
  }

  function uniqueValues(values) {
    var seen = new Set();

    return values.filter(function (value) {
      var normalized = String(value || '').trim();

      if (!normalized || seen.has(normalized)) {
        return false;
      }

      seen.add(normalized);
      return true;
    });
  }

  function getLanguageCode() {
    return String(config.language || document.documentElement.lang || 'fi').toLowerCase().split('-')[0];
  }

  function getReleaseCountdownTextFallbacks() {
    var code = getLanguageCode();

    if (code === 'sv') {
      return {
        label: 'Tillgänglig:',
        dayOne: 'dag',
        dayMany: 'dagar',
        openText: 'Datum öppet'
      };
    }

    if (code === 'en') {
      return {
        label: 'Available:',
        dayOne: 'day',
        dayMany: 'days',
        openText: 'Date TBA'
      };
    }

    return {
      label: 'Saatavilla:',
      dayOne: 'päivä',
      dayMany: 'päivää',
      openText: 'Ajankohta avoin'
    };
  }

  function getColorGroupLabel(group) {
    var code = getLanguageCode();

    return (group.labels && (group.labels[code] || group.labels.en || group.labels.fi)) || group.key;
  }

  function colorAliasMatches(key, compactKey, alias) {
    var normalizedAlias = normalizeColorKey(alias);
    var compactAlias = normalizedAlias.replace(/\s+/g, '');

    return key === normalizedAlias || compactKey === compactAlias;
  }

  function getColorGroupsForValue(value) {
    var label = String(value || '').trim();
    var key = normalizeColorKey(label);
    var compactKey = key.replace(/\s+/g, '');
    var groups = [];

    if (!label) {
      return groups;
    }

    COLOR_GROUPS.forEach(function (group) {
      var matches = (group.aliases || []).some(function (alias) {
        return colorAliasMatches(key, compactKey, alias);
      });

      if (matches) {
        groups.push(getColorGroupLabel(group));
      }
    });

    return groups;
  }

  function getColorPatternValues(product) {
    var values = getMetafieldValues(product.colorPattern);
    var splitValues = [];

    values.forEach(function (value) {
      String(value || '').split(/\s*,\s*/).forEach(function (part) {
        if (part) {
          getColorGroupsForValue(part).forEach(function (group) {
            splitValues.push(group);
          });
        }
      });
    });

    return uniqueValues(splitValues);
  }

  function normalizeColorKey(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function getColorSwatchStyle(label) {
    var key = normalizeColorKey(label);
    var compactKey = key.replace(/\s+/g, '');

    if (COLOR_SWATCH_STYLES[key]) {
      return COLOR_SWATCH_STYLES[key];
    }

    if (COLOR_SWATCH_STYLES[compactKey]) {
      return COLOR_SWATCH_STYLES[compactKey];
    }

    if (key.indexOf('multi') > -1 || key.indexOf('monivar') > -1 || key.indexOf('flerfarg') > -1) {
      return COLOR_SWATCH_STYLES.multicolor;
    }

    return 'background: rgba(255, 255, 255, 0.08);';
  }

  function isRangeFacetKey(facetKey) {
    return facetKey === 'custom.nopeus' ||
      facetKey === 'custom.liito' ||
      facetKey === 'custom.vakaus' ||
      facetKey === 'custom.feidi';
  }

  function inputFacetKey(input) {
    if (!input) {
      return '';
    }

    if (Object.prototype.hasOwnProperty.call(input, 'productVendor')) {
      return 'vendor';
    }

    if (input.productMetafield) {
      return input.productMetafield.namespace + '.' + input.productMetafield.key;
    }

    if (Object.prototype.hasOwnProperty.call(input, 'tag')) {
      return 'tag';
    }

    return stableFilterKey(input);
  }

  function productMetafieldKey(namespace, key) {
    if (namespace === 'custom' && key === 'nopeus') return 'nopeus';
    if (namespace === 'custom' && key === 'liito') return 'liito';
    if (namespace === 'custom' && key === 'vakaus') return 'vakaus';
    if (namespace === 'custom' && key === 'feidi') return 'feidi';
    if (namespace === 'custom' && key === 'profile') return 'profile';
    if (namespace === 'my_fields' && key === 'muovi') return 'muovi';
    if (namespace === 'my_fields' && key === 'kunto') return 'kunto';
    if (namespace === 'shopify' && key === 'color-pattern') return 'colorPattern';
    return '';
  }

  function selectedInputMatches(product, input) {
    var metafield;

    if (!input) {
      return true;
    }

    if (Object.prototype.hasOwnProperty.call(input, 'productVendor')) {
      return product.vendor === input.productVendor;
    }

    if (Object.prototype.hasOwnProperty.call(input, 'tag')) {
      return (product.tags || []).indexOf(input.tag) > -1;
    }

    if (input.productMetafield) {
      if (input.productMetafield.namespace === 'shopify' && input.productMetafield.key === 'color-pattern') {
        return getColorPatternValues(product).indexOf(String(input.productMetafield.value)) > -1;
      }

      metafield = productMetafieldKey(input.productMetafield.namespace, input.productMetafield.key);
      return getMetafieldValues(product[metafield]).indexOf(String(input.productMetafield.value)) > -1;
    }

    return true;
  }

  function getProductMinPrice(product) {
    return toNumber(product.priceRange && product.priceRange.minVariantPrice && product.priceRange.minVariantPrice.amount, 0);
  }

  function getProductMaxPrice(product) {
    return toNumber(product.priceRange && product.priceRange.maxVariantPrice && product.priceRange.maxVariantPrice.amount, getProductMinPrice(product));
  }

  function matchesPrice(product, state) {
    var min = state.priceMin === null ? 0 : state.priceMin;
    var max = state.priceMax === null ? Number.POSITIVE_INFINITY : state.priceMax;

    return getProductMaxPrice(product) >= min && getProductMinPrice(product) <= max;
  }

  function normalizeSearchText(value) {
    return String(value || '').toLowerCase();
  }

  function matchesQuery(product, query) {
    var parts = normalizeSearchText(query).split(/\s+/).filter(Boolean);
    var haystack;

    if (!parts.length) {
      return true;
    }

    haystack = [
      product.title,
      product.handle,
      product.vendor,
      (product.tags || []).join(' '),
      getMetafieldValues(product.muovi).join(' '),
      getMetafieldValues(product.kunto).join(' '),
      getColorPatternValues(product).join(' '),
      getMetafieldValues(product.profile).join(' ')
    ].join(' ').toLowerCase();

    return parts.every(function (part) {
      return haystack.indexOf(part) > -1;
    });
  }

  function filterProducts(state, options) {
    var excludedFacet = options && options.excludeFacet;
    var excludePrice = options && options.excludePrice;
    var grouped = {};
    var facetKeys;

    state.selected.forEach(function (item) {
      var key = inputFacetKey(item.input);
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(item);
    });

    facetKeys = Object.keys(grouped);

    return state.indexProducts.filter(function (product) {
      if (!matchesQuery(product, state.query)) {
        return false;
      }

      if (!excludePrice && !matchesPrice(product, state)) {
        return false;
      }

      return facetKeys.every(function (facetKey) {
        if (excludedFacet && facetKey === excludedFacet) {
          return true;
        }

        return grouped[facetKey].some(function (item) {
          return selectedInputMatches(product, item.input);
        });
      });
    });
  }

  function sortProducts(state, products) {
    var sorted = products.slice();
    var query = normalizeSearchText(state.query);

    function compareSourceOrder(a, b) {
      return toNumber(a.sourceOrder, 0) - toNumber(b.sourceOrder, 0);
    }

    function createdTimestamp(product) {
      var timestamp = toNumber(product.createdAtTimestamp, NaN);
      var parsed;

      if (Number.isFinite(timestamp) && timestamp > 0) {
        return timestamp;
      }

      parsed = Date.parse(product.createdAt || '');
      return Number.isFinite(parsed) ? parsed / 1000 : 0;
    }

    if (state.sortBy === 'price-ascending') {
      sorted.sort(function (a, b) {
        return getProductMinPrice(a) - getProductMinPrice(b) || compareSourceOrder(a, b);
      });
    } else if (state.sortBy === 'price-descending') {
      sorted.sort(function (a, b) {
        return getProductMinPrice(b) - getProductMinPrice(a) || compareSourceOrder(a, b);
      });
    } else if (state.sortBy === 'title-ascending' || state.sortBy === 'alpha-ascending') {
      sorted.sort(function (a, b) {
        return String(a.title || '').localeCompare(String(b.title || ''), undefined, { sensitivity: 'base' }) || compareSourceOrder(a, b);
      });
    } else if (state.sortBy === 'title-descending' || state.sortBy === 'alpha-descending') {
      sorted.sort(function (a, b) {
        return String(b.title || '').localeCompare(String(a.title || ''), undefined, { sensitivity: 'base' }) || compareSourceOrder(a, b);
      });
    } else if (state.sortBy === 'created-ascending' || state.sortBy === 'date-ascending') {
      sorted.sort(function (a, b) {
        return createdTimestamp(a) - createdTimestamp(b) || compareSourceOrder(a, b);
      });
    } else if (state.sortBy === 'created-descending' || state.sortBy === 'date-descending') {
      sorted.sort(function (a, b) {
        return createdTimestamp(b) - createdTimestamp(a) || compareSourceOrder(a, b);
      });
    } else if (state.sortBy === 'manual' || state.sortBy === 'best-selling') {
      sorted.sort(compareSourceOrder);
    } else if ((state.sortBy === 'relevance' || !state.sortBy) && query) {
      sorted.sort(function (a, b) {
        var aTitle = normalizeSearchText(a.title);
        var bTitle = normalizeSearchText(b.title);
        var aScore = aTitle.indexOf(query) === 0 ? 0 : aTitle.indexOf(query) > -1 ? 1 : 2;
        var bScore = bTitle.indexOf(query) === 0 ? 0 : bTitle.indexOf(query) > -1 ? 1 : 2;

        return aScore - bScore || compareSourceOrder(a, b);
      });
    } else {
      sorted.sort(compareSourceOrder);
    }

    return sorted;
  }

  var CUSTOM_VALUE_ORDER = {
    'custom.profile': ['1 - Concave', '2 - Flat', '3 - Neutral', '4 - Domey', '5 - Very Domey'],
    'my_fields.kunto': ['Uusi', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C']
  };

  function resolveCustomOrder(order) {
    if (!order) return null;
    if (typeof order === 'function') return order();
    if (Array.isArray(order)) return order;
    var code = String(config.language || '').toLowerCase().split('-')[0];
    return order[code] || order.en || order.fi || null;
  }

  function sortByCustomOrder(values, order) {
    values.sort(function (a, b) {
      var aIdx = order.indexOf(a.label);
      var bIdx = order.indexOf(b.label);
      if (aIdx === -1 && bIdx === -1) {
        return String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' });
      }
      if (aIdx === -1) return 1;
      if (bIdx === -1) return -1;
      return aIdx - bIdx;
    });
  }

  function buildFilterValues(definition, products) {
    var counts = new Map();
    var values;
    var customOrder;

    products.forEach(function (product) {
      definition.values(product).forEach(function (value) {
        if (value === '') {
          return;
        }

        counts.set(value, (counts.get(value) || 0) + 1);
      });
    });

    values = Array.from(counts.keys()).map(function (value) {
      return {
        id: definition.id + ':' + value,
        label: value,
        count: counts.get(value) || 0,
        swatch: definition.swatch ? { style: getColorSwatchStyle(value) } : null,
        input: JSON.stringify(definition.input(value))
      };
    });

    customOrder = resolveCustomOrder(CUSTOM_VALUE_ORDER[definition.key]);

    if (definition.range) {
      values.sort(function (a, b) {
        return toNumber(a.label, 0) - toNumber(b.label, 0);
      });
    } else if (customOrder) {
      sortByCustomOrder(values, customOrder);
    } else {
      values.sort(function (a, b) {
        return (b.count || 0) - (a.count || 0) || String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' });
      });
    }

    return values;
  }

  function getPriceFilter(state) {
    return {
      id: 'filter.v.price',
      label: t('filters_price', 'Price'),
      type: 'PRICE_RANGE',
      values: []
    };
  }

  function buildFilters(state) {
    var definitions = getFacetDefinitions();
    var priceBase = filterProducts(state, { excludePrice: true });
    var maxPrice = priceBase.reduce(function (max, product) {
      return Math.max(max, getProductMaxPrice(product));
    }, 0);
    var minPrice = priceBase.reduce(function (min, product) {
      var price = getProductMinPrice(product);
      if (price <= 0) return min;
      return min === null ? price : Math.min(min, price);
    }, null);
    var filters = [];

    state.priceBoundMin = minPrice === null ? 0 : Math.floor(minPrice);
    state.priceBoundMax = Math.ceil(maxPrice);
    if (state.priceMax !== null && state.priceMax >= state.priceBoundMax) {
      state.priceMax = null;
    }
    if (state.priceMin !== null && state.priceMin <= state.priceBoundMin) {
      state.priceMin = null;
    }

    if (state.priceBoundMax > 0 && state.priceBoundMax > state.priceBoundMin) {
      filters.push(getPriceFilter(state));
    }

    definitions.forEach(function (definition) {
      var base;
      var values;
      var numericValues;

      try {
        base = filterProducts(state, { excludeFacet: definition.key });
        values = buildFilterValues(definition, base);
      } catch (error) {
        console.warn('[KiekkoKingi] Skipping headless filter "' + definition.key + '":', error);
        return;
      }

      if (definition.range) {
        numericValues = values.map(function (value) {
          return toNumber(value.label, 0);
        });

        if (numericValues.length <= 1 || Math.min.apply(Math, numericValues) === Math.max.apply(Math, numericValues)) {
          return;
        }
      }

      if (values.length > 1) {
        filters.push({
          id: definition.id,
          label: definition.label,
          type: 'LIST',
          range: Boolean(definition.range),
          swatch: Boolean(definition.swatch),
          values: values
        });
      }
    });

    state.filters = filters;
    return filters;
  }

  function readUrlState(state) {
    var params = new URLSearchParams(window.location.search);
    var encoded = params.get('kkf');
    var decoded;
    var selected;

    state.query = params.get('q') || '';
    state.sortBy = params.get('sort_by') || state.sortBy || '';
    state.priceMin = params.get('kk_price_min') ? toNumber(params.get('kk_price_min'), null) : null;
    state.priceMax = params.get('kk_price_max') ? toNumber(params.get('kk_price_max'), null) : null;

    if (encoded) {
      decoded = decodeBase64Url(encoded);

      try {
        selected = JSON.parse(decoded);
      } catch (error) {
        selected = [];
      }

      if (Array.isArray(selected)) {
        selected.forEach(function (item) {
          if (!item || !item.input) {
            return;
          }

          state.selected.set(stableFilterKey(item.input), {
            input: item.input,
            label: item.label || '',
            filterLabel: item.filterLabel || ''
          });
        });
      }
    }
  }

  function writeUrlState(state) {
    var url = new URL(window.location.href);
    var filters = [];

    url.searchParams.delete('page');
    url.searchParams.delete('kkf');
    url.searchParams.delete('kk_price_min');
    url.searchParams.delete('kk_price_max');

    Array.from(url.searchParams.keys()).forEach(function (name) {
      if (name.indexOf('filter.') === 0) {
        url.searchParams.delete(name);
      }
    });

    if (state.query) {
      url.searchParams.set('q', state.query);
    } else {
      url.searchParams.delete('q');
    }

    if (state.sortBy) {
      url.searchParams.set('sort_by', state.sortBy);
    }

    state.selected.forEach(function (item) {
      filters.push({
        input: item.input,
        label: item.label,
        filterLabel: item.filterLabel
      });
    });

    if (filters.length) {
      url.searchParams.set('kkf', encodeBase64Url(JSON.stringify(filters)));
    }

    if (state.priceMin !== null) {
      url.searchParams.set('kk_price_min', state.priceMin);
    }

    if (state.priceMax !== null) {
      url.searchParams.set('kk_price_max', state.priceMax);
    }

    window.history.replaceState({}, '', url.pathname + (url.search ? url.search : ''));
  }

  function getResultsContainer(state) {
    return state.root.querySelector('[data-results-container]');
  }

  function getSidebar(state) {
    return state.root.querySelector('[data-product-grid-sidebar]');
  }

  function getCacheKey(state) {
    return [
      'kk-headless-index-v11',
      state.handle,
      config.country || '',
      config.language || '',
      config.currencyCode || '',
      state.collectionCount || '',
      state.indexSortBy || getNativeIndexSort(state.sortBy) || 'default'
    ].join(':');
  }

  function readIndexCache(state) {
    var raw;
    var cached;

    try {
      raw = window.localStorage.getItem(getCacheKey(state));
      if (!raw) {
        return null;
      }

      cached = JSON.parse(raw);
      if (!cached || !cached.createdAt || !Array.isArray(cached.products) || cached.products.length === 0) {
        if (cached && Array.isArray(cached.products) && cached.products.length === 0) {
          window.localStorage.removeItem(getCacheKey(state));
        }
        return null;
      }

      if (Date.now() - cached.createdAt > INDEX_CACHE_TTL) {
        window.localStorage.removeItem(getCacheKey(state));
        return null;
      }

      return cached.products;
    } catch (error) {
      return null;
    }
  }

  function writeIndexCache(state, products) {
    if (!products || !products.length) {
      return;
    }

    try {
      window.localStorage.setItem(getCacheKey(state), JSON.stringify({
        createdAt: Date.now(),
        products: products
      }));
    } catch (error) {
      // Large collections can exceed browser storage quotas. The live index still works without cache.
    }
  }

  function resetIndex(state) {
    state.indexGeneration += 1;
    state.indexProducts = [];
    state.indexLoaded = false;
    state.indexPromise = null;
    state.partialRendered = false;
    state.filters = [];
    state.root.classList.remove('kk-headless-collection--partial-index');
  }

  function renderIndexLoading(state, count) {
    var sidebar = getSidebar(state);
    var total = state.collectionCount || 0;
    var label = t('collection_search_loading', 'Loading');
    var text = label;
    var existingTextNodes;
    var existingWrapper;
    var loadingInnerHtml;

    if (count) {
      text = total ? label + ' ' + count + ' / ' + total : label + ' ' + count;
    }

    existingTextNodes = document.querySelectorAll('[data-kk-headless-index-loading-text]');
    if (existingTextNodes.length) {
      existingTextNodes.forEach(function (node) {
        node.textContent = text;
      });
      return;
    }

    if (state.partialRendered || state.indexLoaded) {
      return;
    }

    if (!sidebar) {
      return;
    }

    loadingInnerHtml = '<div class="kk-headless-index-loading__text" data-kk-headless-index-loading-text>' + escapeHtml(text) + '</div>';
    existingWrapper = sidebar.querySelector('[data-kk-headless-filters-content]');

    if (existingWrapper) {
      existingWrapper.classList.add('kk-headless-index-loading');
      existingWrapper.setAttribute('data-kk-headless-index-loading', '');
      existingWrapper.innerHTML = loadingInnerHtml;
    } else {
      sidebar.querySelectorAll('[data-productgrid-filters-content]').forEach(function (node) {
        node.remove();
      });
      sidebar.insertAdjacentHTML('afterbegin', [
        '<div class="productgrid--sidebar-section kk-headless-index-loading" data-productgrid-filters-content data-kk-headless-filters-content data-kk-headless-index-loading>',
        loadingInnerHtml,
        '</div>'
      ].join(''));
    }

    state.root.classList.add('kk-headless-collection--has-filters');
    updateFilterTrigger(state);
  }

  function setProcessing(state, processing) {
    var container = getResultsContainer(state);

    if (container) {
      container.classList.toggle('processing--filter', processing);
    }

    state.root.classList.toggle('kk-headless-collection--processing', processing);
  }

  function normalizeFilterLabel(filter) {
    var label = filter && filter.label ? filter.label : '';
    var sampleInput = filter && filter.values && filter.values[0] ? filter.values[0].input : '';
    var labelDowncase = label.toLowerCase();

    if (filter && filter.type === 'PRICE_RANGE') {
      return t('filters_price', label || 'Price');
    }

    if (sampleInput.indexOf('nopeus') > -1 || labelDowncase === 'nopeus') {
      return t('flight_numbers_speed', 'Speed');
    }

    if (sampleInput.indexOf('liito') > -1 || labelDowncase === 'liito') {
      return t('flight_numbers_glide', 'Glide');
    }

    if (sampleInput.indexOf('vakaus') > -1 || labelDowncase === 'vakaus') {
      return t('flight_numbers_turn', 'Turn');
    }

    if (sampleInput.indexOf('feidi') > -1 || labelDowncase === 'feidi') {
      return t('flight_numbers_fade', 'Fade');
    }

    if (sampleInput.indexOf('muovi') > -1 || labelDowncase === 'muovi') {
      return t('disc_plastic', 'Plastic');
    }

    if (sampleInput.indexOf('color-pattern') > -1 || labelDowncase === 'väri' || labelDowncase === 'vari' || labelDowncase === 'color' || labelDowncase === 'färg' || labelDowncase === 'farg') {
      return t('disc_color', 'Color');
    }

    if (sampleInput.indexOf('kunto') > -1 || labelDowncase === 'kunto') {
      return t('disc_condition', 'Condition');
    }

    return label;
  }

  function normalizeValueLabel(filter, value) {
    var label = value && value.label ? value.label : '';
    var filterInput = filter && filter.values && filter.values[0] ? filter.values[0].input : '';

    if (filterInput.indexOf('kunto') > -1 && label.toLowerCase() === 'uusi') {
      return t('disc_condition_new', 'New');
    }

    return label;
  }

  function isDiscRangeFilter(filter) {
    var sampleInput = filter && filter.values && filter.values[0] ? filter.values[0].input : '';
    var label = filter && filter.label ? filter.label.toLowerCase() : '';

    return Boolean(filter && filter.range) ||
      sampleInput.indexOf('nopeus') > -1 ||
      sampleInput.indexOf('liito') > -1 ||
      sampleInput.indexOf('vakaus') > -1 ||
      sampleInput.indexOf('feidi') > -1 ||
      label === 'nopeus' ||
      label === 'liito' ||
      label === 'vakaus' ||
      label === 'feidi';
  }

  function getSortedValues(filter) {
    return (filter.values || []).slice();
  }

  function findPriceFilter(filters) {
    return (filters || []).find(function (filter) {
      return filter.type === 'PRICE_RANGE';
    });
  }

  function getListFilters(filters) {
    return (filters || []).filter(function (filter) {
      return filter.type !== 'PRICE_RANGE';
    });
  }

  function isSelected(state, input) {
    return state.selected.has(stableFilterKey(input));
  }

  function renderPriceFilter(state, filter) {
    var min = Math.max(0, Math.floor(state.priceBoundMin || 0));
    var max = Math.max(min, Math.ceil(state.priceBoundMax || 0));
    var minValue = state.priceMin === null ? min : state.priceMin;
    var maxValue = state.priceMax === null ? max : state.priceMax;
    var currencyCode = state.currencyCode || config.currencyCode || 'EUR';
    var symbol = getCurrencySymbol(currencyCode);
    var label = normalizeFilterLabel(filter);

    if (!max) {
      return '';
    }

    return [
      '<details class="kk-facet" open data-kk-headless-facet>',
      '<summary class="kk-facet__summary"><span class="kk-facet__title">', escapeHtml(label), ' (', escapeHtml(symbol || currencyCode), ')</span></summary>',
      '<div class="kk-facet__body">',
      '<div class="collection-filters__price-range-form productgrid--sidebar-item filter-group kk-range-filter kk-range-filter--price" data-kk-headless-price-range data-kk-headless-range-min="', escapeHtml(min), '" data-kk-headless-range-max="', escapeHtml(max), '">',
      '<div class="collection-filters__filter collection-filters__filter-range">',
      '<div class="kk-range-filter__fields">',
      '<div class="collection-filters__filter-range--from kk-range-filter__field"><span class="collection-filters__filter-range-currency">', escapeHtml(symbol), '</span>',
      '<input class="collection-filters__filter-range-input kk-range-filter__number" type="number" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="0.01" value="', escapeHtml(minValue), '" data-kk-headless-price-min aria-label="', escapeHtml(label), ' minimum"></div>',
      '<span class="kk-range-filter__separator" aria-hidden="true">-</span>',
      '<div class="collection-filters__filter-range--to kk-range-filter__field"><span class="collection-filters__filter-range-currency">', escapeHtml(symbol), '</span>',
      '<input class="collection-filters__filter-range-input kk-range-filter__number" type="number" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="0.01" value="', escapeHtml(maxValue), '" data-kk-headless-price-max aria-label="', escapeHtml(label), ' maximum"></div>',
      '</div>',
      '<div class="kk-range-filter__slider" data-kk-headless-price-track data-kk-tooltip-prefix="', escapeHtml(symbol), '">',
      '<input class="kk-range-filter__range kk-range-filter__range--lower" type="range" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="1" value="', escapeHtml(Math.floor(minValue)), '" data-kk-headless-price-lower aria-label="', escapeHtml(label), ' minimum">',
      '<input class="kk-range-filter__range kk-range-filter__range--upper" type="range" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="1" value="', escapeHtml(Math.ceil(maxValue)), '" data-kk-headless-price-upper aria-label="', escapeHtml(label), ' maximum">',
      '<span class="kk-range-filter__tooltip kk-range-filter__tooltip--lower" data-kk-range-tooltip="lower" aria-hidden="true"></span>',
      '<span class="kk-range-filter__tooltip kk-range-filter__tooltip--upper" data-kk-range-tooltip="upper" aria-hidden="true"></span>',
      '</div>',
      '<div class="kk-range-filter__bounds" aria-hidden="true"><span>', escapeHtml(min), '</span><span>', escapeHtml(max), '</span></div>',
      '</div>',
      '</div>',
      '</div>',
      '</details>'
    ].join('');
  }

  function renderRangeFilter(state, filter) {
    var label = normalizeFilterLabel(filter);
    var values = getSortedValues(filter);
    var numericValues = values.map(function (value) {
      return toNumber(value.label, 0);
    });
    var min = Math.floor(Math.min.apply(Math, numericValues));
    var max = Math.ceil(Math.max.apply(Math, numericValues));
    var active = values.filter(function (value) {
      return isSelected(state, parseFilterInput(value.input));
    }).map(function (value) {
      return toNumber(value.label, 0);
    });
    var activeMin = active.length ? Math.min.apply(Math, active) : min;
    var activeMax = active.length ? Math.max.apply(Math, active) : max;
    var options = values.map(function (value) {
      return '<input type="hidden" data-kk-headless-range-option value="' + escapeHtml(value.input) + '" data-kk-headless-range-value="' + escapeHtml(toNumber(value.label, 0)) + '" data-kk-headless-range-label="' + escapeHtml(normalizeValueLabel(filter, value)) + '" data-kk-headless-filter-label="' + escapeHtml(label) + '">';
    }).join('');

    if (!values.length || min === max) {
      return '';
    }

    return [
      '<details class="kk-facet" open data-kk-headless-facet>',
      '<summary class="kk-facet__summary"><span class="kk-facet__title">', escapeHtml(label), '</span></summary>',
      '<div class="kk-facet__body">',
      '<div class="kk-range-filter kk-range-filter--metafield" data-kk-headless-native-range data-kk-headless-range-min="', escapeHtml(min), '" data-kk-headless-range-max="', escapeHtml(max), '">',
      '<div class="kk-range-filter__fields">',
      '<input class="kk-range-filter__number" type="number" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="1" value="', escapeHtml(activeMin), '" data-kk-headless-range-min-input aria-label="', escapeHtml(label), ' minimum">',
      '<span class="kk-range-filter__separator" aria-hidden="true">-</span>',
      '<input class="kk-range-filter__number" type="number" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="1" value="', escapeHtml(activeMax), '" data-kk-headless-range-max-input aria-label="', escapeHtml(label), ' maximum">',
      '</div>',
      '<div class="kk-range-filter__slider">',
      '<input class="kk-range-filter__range kk-range-filter__range--lower" type="range" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="1" value="', escapeHtml(activeMin), '" data-kk-headless-range-lower aria-label="', escapeHtml(label), ' minimum">',
      '<input class="kk-range-filter__range kk-range-filter__range--upper" type="range" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="1" value="', escapeHtml(activeMax), '" data-kk-headless-range-upper aria-label="', escapeHtml(label), ' maximum">',
      '<span class="kk-range-filter__tooltip kk-range-filter__tooltip--lower" data-kk-range-tooltip="lower" aria-hidden="true"></span>',
      '<span class="kk-range-filter__tooltip kk-range-filter__tooltip--upper" data-kk-range-tooltip="upper" aria-hidden="true"></span>',
      '</div>',
      '<div class="kk-range-filter__bounds" aria-hidden="true"><span>', escapeHtml(min), '</span><span>', escapeHtml(max), '</span></div>',
      options,
      '</div>',
      '</div>',
      '</details>'
    ].join('');
  }

  function renderHeadlessSwatch(value, label) {
    var swatch = value && value.swatch ? value.swatch : null;
    var style = swatch && swatch.style ? swatch.style : getColorSwatchStyle(label);

    return [
      '<span class="faceted-filter-swatch">',
      '<span class="faceted-filter-swatch__color" style="', escapeHtml(style), '"></span>',
      '</span>'
    ].join('');
  }

  function renderListFilter(state, filter) {
    var label = normalizeFilterLabel(filter);
    var values = getSortedValues(filter);
    var showSearch = values.length > state.tagLimit;
    var isSwatch = Boolean(filter.swatch);
    var filterGroupClass = isSwatch ? 'filter-group--swatch' : 'filter-group--text';
    var toggleMoreText = isSwatch ? t('filters_show_all', 'Show all') : t('see_more', 'See more');
    var toggleLessText = isSwatch ? t('filters_show_less', 'Show less') : t('see_less', 'See less');
    var items = values.map(function (value, index) {
      var input = parseFilterInput(value.input);
      var checked = isSelected(state, input);
      var disabled = !checked && value.count === 0;
      var displayLabel = normalizeValueLabel(filter, value);

      return [
        '<li class="filter-item kk-facet__item ', checked ? 'filter-item--active' : 'filter-item--inactive', index >= state.tagLimit ? ' filter-item--hidden' : '', disabled ? ' filter-item--disabled' : '', '" data-kk-headless-filter-option data-kk-headless-filter-search-text="', escapeHtml(displayLabel.toLowerCase()), '" ', index >= state.tagLimit ? 'data-hidden-default' : '', '>',
        '<label class="filter-item__label kk-facet__label ', disabled ? 'filter-item__label--disabled' : '', '">',
        '<input class="faceted-filter__checkbox" type="checkbox" ', checked ? 'checked' : '', disabled ? 'disabled' : '', ' data-kk-headless-filter-input value="', escapeHtml(value.input), '" data-kk-headless-filter-label="', escapeHtml(label), '" data-kk-headless-value-label="', escapeHtml(displayLabel), '">',
        isSwatch ? renderHeadlessSwatch(value, displayLabel) : '<span class="filter-icon--checkbox" aria-hidden="true"></span>',
        '<span class="faceted-filter__label-text kk-facet__label-text"><span class="kk-facet__value">', escapeHtml(displayLabel), '</span>',
        state.showProductCounts ? '<span class="kk-facet__count">(' + escapeHtml(value.count || 0) + ')</span>' : '',
        '</span></label></li>'
      ].join('');
    }).join('');

    if (!values.length) {
      return '';
    }

    return [
      '<details class="kk-facet" open data-kk-headless-facet>',
      '<summary class="kk-facet__summary"><span class="kk-facet__title">', escapeHtml(label), '</span></summary>',
      '<div class="kk-facet__body">',
      showSearch ? '<label class="kk-facet__search"><span class="visually-hidden">Search</span><input class="kk-facet__search-input" type="search" placeholder="' + escapeHtml(t('filters_search_options', 'Search options')) + '" autocomplete="off" data-kk-headless-filter-search></label>' : '',
      '<ul class="productgrid--sidebar-item filter-group ', escapeHtml(filterGroupClass), ' kk-facet__list" data-kk-headless-filter-list>',
      items,
      values.length > state.tagLimit ? '<li class="filter-item filter-item--toggle-more kk-facet__toggle-more"><a class="filter-text--link" href="#" data-kk-headless-toggle-more="false" data-kk-headless-see-more-text="' + escapeHtml(toggleMoreText) + '" data-kk-headless-see-less-text="' + escapeHtml(toggleLessText) + '">' + escapeHtml(toggleMoreText) + '</a></li>' : '',
      '</ul>',
      '</div>',
      '</details>'
    ].join('');
  }

  function refreshOpenFilterModal() {
    var modalContainer = document.querySelector('[data-modal-container]');
    var modalContent = modalContainer && modalContainer.querySelector('[data-modal-content]');
    var sidebarFilterContent = document.querySelector('[data-product-grid-sidebar] [data-productgrid-filters-content]');
    var modalIsOpenForFilters = modalContainer && modalContainer.classList.contains('modal--productgrid-filters');

    if (!modalIsOpenForFilters || !modalContent || !sidebarFilterContent) {
      return;
    }

    while (modalContent.firstChild) {
      modalContent.removeChild(modalContent.firstChild);
    }

    while (sidebarFilterContent.firstChild) {
      modalContent.appendChild(sidebarFilterContent.firstChild);
    }
  }

  function renderFilters(state) {
    var sidebar = getSidebar(state);
    var priceFilter = findPriceFilter(state.filters);
    var filters = getListFilters(state.filters);
    var filterHtml = '';
    var innerHtml;
    var existingContent;

    if (priceFilter) {
      filterHtml += renderPriceFilter(state, priceFilter);
    }

    filters.forEach(function (filter) {
      filterHtml += isDiscRangeFilter(filter) ? renderRangeFilter(state, filter) : renderListFilter(state, filter);
    });

    innerHtml = [
      '<h2 class="productgrid--sidebar-title visually-hidden">', escapeHtml(t('filters_title_count_zero', 'Filters')), '</h2>',
      '<nav aria-label="Collection filters">',
      '<form class="faceted-filter__form kk-facets" data-kk-headless-facets>',
      filterHtml,
      '</form>',
      '</nav>',
      '<button class="kk-filter-results-button" type="button" data-modal-close data-kk-headless-filter-results data-kk-filter-results-button>', escapeHtml(t('filters_show_results', 'Show results')), '</button>'
    ].join('');

    if (sidebar) {
      sidebar.querySelectorAll('[data-productgrid-filters-content]').forEach(function (node) {
        if (!node.hasAttribute('data-kk-headless-filters-content')) {
          node.remove();
        }
      });

      existingContent = sidebar.querySelector('[data-kk-headless-filters-content]');

      if (existingContent) {
        existingContent.classList.remove('kk-headless-index-loading');
        existingContent.removeAttribute('data-kk-headless-index-loading');
        existingContent.setAttribute('data-faceted-filters', '');
        existingContent.innerHTML = innerHtml;
      } else {
        sidebar.insertAdjacentHTML('afterbegin', [
          '<div class="productgrid--sidebar-section" data-productgrid-filters-content data-faceted-filters data-kk-headless-filters-content>',
          innerHtml,
          '</div>'
        ].join(''));
      }
    }

    if (state.indexLoaded || state.partialRendered) {
      refreshOpenFilterModal();
    }

    state.root.classList.toggle('kk-headless-collection--has-filters', Boolean(filterHtml));
    updateFilterTrigger(state);
    updateAllRangeTooltips(state);
  }

  function renderFlightNumbers(product) {
    var parts = [
      ['nopeus', t('flight_numbers_speed', 'Speed')],
      ['liito', t('flight_numbers_glide', 'Glide')],
      ['vakaus', t('flight_numbers_turn', 'Turn')],
      ['feidi', t('flight_numbers_fade', 'Fade')]
    ];
    var items = parts.map(function (part) {
      var value = getMetafieldValues(product[part[0]])[0];

      return value ? '<div class="tooltip">' + escapeHtml(value) + '<span class="tooltiptext">' + escapeHtml(part[1]) + '</span></div>' : '';
    }).join('');

    return items ? '<div class="flight-numbers">' + items + '</div>' : '';
  }

  function stateCurrency(product) {
    var minPrice = product.priceRange && product.priceRange.minVariantPrice;

    return minPrice ? minPrice.currencyCode : config.currencyCode || 'EUR';
  }

  function renderProductPrice(product) {
    var minPrice = product.priceRange && product.priceRange.minVariantPrice;
    var maxPrice = product.priceRange && product.priceRange.maxVariantPrice;
    var compareMin = product.compareAtPriceRange && product.compareAtPriceRange.minVariantPrice;
    var price = minPrice ? toNumber(minPrice.amount, 0) : 0;
    var comparePrice = compareMin ? toNumber(compareMin.amount, 0) : 0;
    var currency = minPrice ? minPrice.currencyCode : stateCurrency(product);
    var varies = maxPrice && toNumber(maxPrice.amount, price) !== price;
    var priceHtml = varies ?
      t('price_range_html', '[[price]]').replace('[[price]]', formatMoney(price, currency)) :
      formatMoney(price, currency);
    var priceMarkup = varies ? priceHtml : '<span class="money">' + escapeHtml(priceHtml) + '</span>';
    var compareHtml = comparePrice > price ?
      '<div class="price--compare-at visible" data-price-compare-at><span class="visually-hidden">' + escapeHtml(t('original_price', 'Original price')) + '</span><span class="money">' + escapeHtml(formatMoney(comparePrice, currency)) + '</span></div>' :
      '<div class="price--compare-at visible" data-price-compare-at><span class="price--spacer"></span></div>';

    return [
      '<div class="productitem--price">',
      compareHtml,
      '<div class="price--main" data-price>',
      comparePrice > price ? '<span class="visually-hidden">' + escapeHtml(t('current_price', 'Current price')) + '</span>' : '',
      priceMarkup,
      '</div>',
      '</div>'
    ].join('');
  }

  function shouldRenderJudgeMePreviewBadge() {
    return config.productReviewsEnabled !== false && config.productGridStarRatingsEnabled !== false;
  }

  function getJudgeMeProductId(product) {
    var gidMatch;

    if (product.legacyId) {
      return String(product.legacyId);
    }

    gidMatch = String(product.id || '').match(/Product\/(\d+)$/);
    return gidMatch ? gidMatch[1] : '';
  }

  function renderJudgeMePreviewBadge(product) {
    var productId;

    if (!shouldRenderJudgeMePreviewBadge()) {
      return '';
    }

    productId = getJudgeMeProductId(product);
    if (!productId) {
      return '';
    }

    return [
      '<div style="" class="jdgm-widget jdgm-preview-badge" data-id="',
      escapeHtml(productId),
      '" data-template="collection" data-auto-install="false">',
      product.judgeMeBadgeHtml || '',
      '</div>'
    ].join('');
  }

  function runJudgeMeRefresh() {
    var jdgm = window.jdgm;
    var methods = ['initializeWidgets', 'renderWidgets', 'renderBadges'];
    var i;

    if (!jdgm) {
      return false;
    }

    for (i = 0; i < methods.length; i += 1) {
      if (typeof jdgm[methods[i]] === 'function') {
        try {
          jdgm[methods[i]]();
          return true;
        } catch (error) {
          return false;
        }
      }
    }

    return false;
  }

  function refreshJudgeMeWidgets() {
    if (!shouldRenderJudgeMePreviewBadge()) {
      return;
    }

    if (runJudgeMeRefresh()) {
      return;
    }

    window.setTimeout(runJudgeMeRefresh, 250);
  }

  function renderProductCard(product) {
    var image = product.featuredImage;
    var imageHtml = image ?
      '<img src="' + escapeHtml(image.url) + '" alt="' + escapeHtml(image.altText || product.title || '') + '" class="productitem--image-primary" loading="lazy">' :
      '';
    var tags = product.tags || [];
    var isUsed = tags.indexOf('Used') > -1;
    var releaseTimestamp = toNumber(product.releaseTimestamp, 0);
    var isFutureRelease = releaseTimestamp && releaseTimestamp * 1000 > Date.now();
    var soldOut = !product.availableForSale;
    var onSale = product.compareAtPriceRange &&
      product.compareAtPriceRange.minVariantPrice &&
      product.priceRange &&
      product.priceRange.minVariantPrice &&
      toNumber(product.compareAtPriceRange.minVariantPrice.amount, 0) > toNumber(product.priceRange.minVariantPrice.amount, 0);
    var badgeText = product.badgeText ? String(product.badgeText).trim() : '';
    var badgeColor = product.badgeColor ? String(product.badgeColor).trim() : '';
    var customBadgeHtml = badgeText && !isFutureRelease ?
      '<span class="productitem--custom-badge"' + (badgeColor ? ' style="--badge-bg: ' + escapeHtml(badgeColor) + '"' : '') + '>' + escapeHtml(badgeText) + '</span>' :
      '';
    var countdownTextFallbacks = getReleaseCountdownTextFallbacks();
    var countdownLabel = product.releaseCountdownLabel || countdownTextFallbacks.label;
    var countdownDayOne = product.releaseCountdownDayOne || countdownTextFallbacks.dayOne;
    var countdownDayMany = product.releaseCountdownDayMany || countdownTextFallbacks.dayMany;
    var countdownOpenText = product.releaseCountdownOpenText || countdownTextFallbacks.openText;
    var launchCountdownHtml = isFutureRelease ?
      '<span class="productitem--launch-countdown" data-grid-launch-countdown data-target="' + escapeHtml(releaseTimestamp) + '" data-day-one="' + escapeHtml(countdownDayOne) + '" data-day-many="' + escapeHtml(countdownDayMany) + '" data-open-text="' + escapeHtml(countdownOpenText) + '" aria-label="' + escapeHtml(countdownLabel) + '">' +
        '<span class="productitem--launch-countdown-label">' + escapeHtml(countdownLabel) + '</span>' +
        '<span class="productitem--launch-countdown-time" data-grid-launch-time>--:--:--</span>' +
      '</span>' :
      '';

    return [
      '<li class="productgrid--item imagestyle--cropped-medium productitem--emphasis ', onSale && !isFutureRelease ? 'productitem--sale' : '', '" data-product-item>',
      '<script type="application/json" data-product-data>', JSON.stringify({
        id: product.id,
        title: product.title,
        handle: product.handle,
        vendor: product.vendor,
        price: Math.round(getProductMinPrice(product) * 100),
        price_max: Math.round(getProductMaxPrice(product) * 100),
        available: product.availableForSale
      }).replace(/<\/script/gi, '<\\/script'), '</script>',
      '<article class="productitem" data-product-item-content>',
      '<a class="productitem--image-link" href="', escapeHtml(buildProductUrl(product.handle)), '" tabindex="-1" data-product-page-link>',
      '<figure class="productitem--image" data-product-item-image>',
      imageHtml,
      isUsed ? '<span class="recycle-logo-container" aria-hidden="true"><img src="' + RECYCLE_ICON + '" alt="" class="recycle-logo"></span>' : '',
      customBadgeHtml,
      soldOut && !isFutureRelease ? '<span class="productitem--badge badge--soldout">' + escapeHtml(t('sold_out', 'Sold out')) + '</span>' : '',
      onSale && !soldOut && !isFutureRelease ? '<span class="productitem--badge badge--sale" data-badge-sales>' + escapeHtml(t('sale', 'Sale')) + '</span>' : '',
      launchCountdownHtml,
      '</figure>',
      '</a>',
      '<div class="productitem--info">',
      renderFlightNumbers(product),
      renderJudgeMePreviewBadge(product),
      renderProductPrice(product),
      product.vendor ? '<span class="productitem--vendor">' + escapeHtml(product.vendor) + '</span>' : '',
      '<h2 class="productitem--title 2"><a href="', escapeHtml(buildProductUrl(product.handle)), '" data-product-page-link>', escapeHtml(product.title), '</a></h2>',
      '</div>',
      '</article>',
      '</li>'
    ].join('');
  }

  function renderProducts(state, products) {
    var container = getResultsContainer(state);
    var list = container && container.querySelector('[data-product-grid]');
    var emptyHtml = '<div class="kk-headless-productgrid__empty">' + escapeHtml(t('collection_search_result_count_other', '0 results').replace('[[count]]', '0')) + '</div>';
    var html;

    if (!container) {
      return;
    }

    if (!list) {
      list = document.createElement('ul');
      list.className = 'productgrid--items productgrid--no-spacing';
      list.setAttribute('data-product-grid', '');
      list.setAttribute('data-html', 'productgridItems');
      container.appendChild(list);
    }

    html = products.map(renderProductCard).join('');
    list.innerHTML = html || emptyHtml;
    container.classList.add('kk-headless-collection-results-active');
    container.setAttribute('data-product-count', String(state.loadedCount));
    renderLoadMore(state);
    renderActiveFilters(state);
    refreshJudgeMeWidgets();
    document.dispatchEvent(new CustomEvent('kk:collection-search-complete', {
      detail: {
        resultCount: state.loadedCount
      }
    }));
  }

  function renderLoadMore(state) {
    var container = getResultsContainer(state);
    var existing = container && container.querySelector('[data-kk-headless-load-more-wrapper]');
    var label = t('pagination_load', 'Load more products');

    if (existing) {
      existing.remove();
    }

    if (!container || state.visibleCount >= state.resultProducts.length) {
      return;
    }

    container.insertAdjacentHTML('beforeend', [
      '<div class="kk-collection-search__pagination" data-kk-headless-load-more-wrapper>',
      '<button class="button-primary kk-collection-search__load-more" type="button" data-kk-headless-load-more>', escapeHtml(label), '</button>',
      '</div>'
    ].join(''));
  }

  function getActiveCount(state) {
    var count = state.selected.size;

    if (state.priceMin !== null || state.priceMax !== null) {
      count += 1;
    }

    return count;
  }

  function renderActiveFilters(state) {
    var container = getResultsContainer(state);
    var existing = container && container.querySelector('.kk-headless-active-filters');
    var items = [];
    var before;
    var currency = state.currencyCode || config.currencyCode || 'EUR';

    if (!container) {
      return;
    }

    if (existing) {
      existing.remove();
    }

    var grouped = new Map();
    state.selected.forEach(function (item, key) {
      var facetKey = inputFacetKey(item.input);
      if (!grouped.has(facetKey)) {
        grouped.set(facetKey, []);
      }
      grouped.get(facetKey).push({ key: key, item: item });
    });

    grouped.forEach(function (entries, facetKey) {
      if (isRangeFacetKey(facetKey) && entries.length > 0) {
        var values = entries.map(function (e) { return toNumber(e.item.label, NaN); }).filter(function (n) { return !isNaN(n); });
        var minVal = values.length ? Math.min.apply(Math, values) : '';
        var maxVal = values.length ? Math.max.apply(Math, values) : '';
        var filterLabel = entries[0].item.filterLabel || '';
        var labelText;

        if (minVal === maxVal) {
          labelText = filterLabel ? filterLabel + ': ' + minVal : String(minVal);
        } else {
          labelText = filterLabel ? filterLabel + ': ' + minVal + ' - ' + maxVal : minVal + ' - ' + maxVal;
        }

        items.push(
          '<li class="filter-item--grid">' +
          '<a href="#" data-kk-headless-remove-range-facet="' + escapeHtml(facetKey) + '">' +
          '<span class="filter-text">' + escapeHtml(labelText) + '</span>' +
          '<span class="filter-icon--remove" aria-hidden="true">x</span>' +
          '</a></li>'
        );
      } else {
        entries.forEach(function (entry) {
          items.push(
            '<li class="filter-item--grid">' +
            '<a href="#" data-kk-headless-remove-filter="' + escapeHtml(entry.key) + '">' +
            '<span class="filter-text">' + escapeHtml(entry.item.filterLabel ? entry.item.filterLabel + ': ' + entry.item.label : entry.item.label) + '</span>' +
            '<span class="filter-icon--remove" aria-hidden="true">x</span>' +
            '</a></li>'
          );
        });
      }
    });

    if (state.priceMin !== null || state.priceMax !== null) {
      items.push(
        '<li class="filter-item--grid">' +
        '<a href="#" data-kk-headless-remove-price>' +
        '<span class="filter-text">' + escapeHtml(formatMoney(state.priceMin === null ? (state.priceBoundMin || 0) : state.priceMin, currency) + ' - ' + formatMoney(state.priceMax === null ? state.priceBoundMax : state.priceMax, currency)) + '</span>' +
        '<span class="filter-icon--remove" aria-hidden="true">x</span>' +
        '</a></li>'
      );
    }

    if (!items.length) {
      updateFilterTrigger(state);
      return;
    }

    items.push(
      '<li class="filter-item--grid-simple">' +
      '<a href="#" data-kk-headless-clear-all>' + escapeHtml(t('filters_remove_all', 'Remove all filters')) + '</a>' +
      '</li>'
    );

    before = container.querySelector('.productgrid--utils') || container.querySelector('[data-product-grid]');
    container.insertBefore(
      document.createRange().createContextualFragment(
        '<div class="productgrid--filters kk-headless-active-filters">' +
        '<ul class="filter-group--grid">' + items.join('') + '</ul>' +
        '</div>'
      ),
      before || null
    );
    updateFilterTrigger(state);
  }

  function updateFilterTrigger(state) {
    var count = getActiveCount(state);
    var trigger = state.root.querySelector('[data-productgrid-trigger-filters]');
    var text = trigger && trigger.querySelector('.utils-filter-text');
    var label = t('filters_title_count_zero', 'Filters').replace(/\d+/, count);

    if (!trigger) {
      return;
    }

    trigger.hidden = !(state.filters && state.filters.length);
    trigger.setAttribute('aria-label', label);

    if (text) {
      text.textContent = label;
    }
  }

  function setSearchInput(state) {
    var input = state.root.querySelector('[data-kk-collection-search-input]');
    var clear = state.root.querySelector('[data-kk-collection-search-clear]');

    if (input) {
      input.value = state.query || '';
    }

    if (clear) {
      clear.hidden = !state.query;
    }
  }

  function watchSidebar(state) {
    var sidebar = getSidebar(state);
    var ourSelector = '[data-kk-headless-filters-content], [data-kk-headless-index-loading]';
    var rerenderTimer = null;
    var observer;

    if (!sidebar || state.sidebarObserver) {
      return;
    }

    observer = new MutationObserver(function (mutations) {
      var lostOurs = false;

      mutations.forEach(function (mutation) {
        mutation.removedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.matches && node.matches(ourSelector)) {
            lostOurs = true;
          }
        });
      });

      if (!lostOurs) {
        return;
      }

      if (sidebar.querySelector(ourSelector)) {
        return;
      }

      if (state.sidebarGuardCount === undefined) {
        state.sidebarGuardCount = 0;
      }

      state.sidebarGuardCount += 1;

      if (state.sidebarGuardCount === 1) {
        console.warn('[KiekkoKingi] Headless filter content removed by external code. Restoring.', new Error('sidebar-guard'));
      }

      if (state.sidebarGuardCount > 5) {
        console.warn('[KiekkoKingi] Headless filter restoration aborted after repeated removals.');
        observer.disconnect();
        return;
      }

      window.clearTimeout(rerenderTimer);
      rerenderTimer = window.setTimeout(function () {
        if (state.indexLoaded && state.filters && state.filters.length) {
          renderFilters(state);
        } else if (state.indexProducts && state.indexProducts.length) {
          renderIndexLoading(state, state.indexProducts.length);
        } else {
          renderIndexLoading(state, 0);
        }
      }, 50);
    });

    observer.observe(sidebar, { childList: true });
    state.sidebarObserver = observer;
  }

  function ensureIndex(state) {
    var cached;
    var requestedIndexSort = getNativeIndexSort(state.sortBy);
    var requestGeneration;

    if (state.indexSortBy !== requestedIndexSort && (state.indexLoaded || state.partialRendered || state.indexPromise)) {
      resetIndex(state);
    }

    state.indexSortBy = requestedIndexSort;

    if (state.indexLoaded) {
      return Promise.resolve(state.indexProducts);
    }

    if (state.partialRendered && state.indexProducts && state.indexProducts.length) {
      return Promise.resolve(state.indexProducts);
    }

    if (state.indexPromise) {
      return state.indexPromise;
    }

    cached = readIndexCache(state);
    if (cached) {
      state.indexProducts = cached;
      state.indexLoaded = true;
      return Promise.resolve(cached);
    }

    renderIndexLoading(state, 0);
    requestGeneration = state.indexGeneration;

    state.indexPromise = fetchLiquidPage(state, 1).then(function (firstPayload) {
      var products = [];
      var totalPages = (firstPayload && firstPayload.pages) || 1;
      var pendingPages = [];
      var pageNumber;

      appendLiquidProducts(state, products, firstPayload);

      for (pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
        pendingPages.push(pageNumber);
      }

      if (!pendingPages.length) {
        return products;
      }

      return runInBatches(pendingPages, INDEX_PARALLEL_BATCH, function (page) {
        return fetchLiquidPage(state, page).then(function (payload) {
          appendLiquidProducts(state, products, payload);
        }).catch(function (error) {
          console.warn('[KiekkoKingi] Index page ' + page + ' failed permanently after retries:', error);
        });
      }).then(function () {
        return products;
      });
    }).then(function (products) {
      var wasPartial = state.partialRendered;

      if (requestGeneration !== state.indexGeneration) {
        return state.indexProducts;
      }

      state.indexProducts = products;
      state.indexLoaded = true;
      state.partialRendered = false;
      state.root.classList.remove('kk-headless-collection--partial-index');
      writeIndexCache(state, products);

      if (wasPartial) {
        applyCollection(state);
      }

      return products;
    }).catch(function (error) {
      console.warn('[KiekkoKingi] Liquid index load failed:', error);
      state.indexPromise = null;
      throw error;
    });

    return state.indexPromise;
  }

  function applyCollection(state, options) {
    var render = !options || options.render !== false;
    var showProcessing = render || state.indexLoaded;

    if (showProcessing) {
      setProcessing(state, true);
    }

    return ensureIndex(state).then(function () {
      var products;

      buildFilters(state);
      products = sortProducts(state, filterProducts(state));
      state.resultProducts = products;
      state.loadedCount = products.length;
      if (!state.visibleCount || state.visibleCount < state.perPage) {
        state.visibleCount = state.perPage;
      }

      renderFilters(state);
      setSearchInput(state);

      if (render) {
        renderProducts(state, products.slice(0, state.visibleCount));
        writeUrlState(state);
      } else {
        renderActiveFilters(state);
      }
    }).catch(function (error) {
      console.warn('[KiekkoKingi] Liquid index load failed:', error);
      state.root.classList.add('kk-headless-collection--error');
    }).finally(function () {
      if (showProcessing) {
        setProcessing(state, false);
      }
    });
  }

  function updateSelectedFromInput(state, input) {
    var parsed = parseFilterInput(input.value);
    var key = stableFilterKey(parsed);

    if (input.checked) {
      state.selected.set(key, {
        input: parsed,
        label: input.getAttribute('data-kk-headless-value-label') || '',
        filterLabel: input.getAttribute('data-kk-headless-filter-label') || ''
      });
    } else {
      state.selected.delete(key);
    }
  }

  function updateRangeTooltips(range) {
    if (!range) return;
    var slider = range.querySelector('[data-kk-headless-price-track]') || range.querySelector('.kk-range-filter__slider');
    if (!slider) return;

    var prefix = slider.getAttribute('data-kk-tooltip-prefix') || '';
    var lower = slider.querySelector('[data-kk-headless-price-lower], [data-kk-headless-range-lower]');
    var upper = slider.querySelector('[data-kk-headless-price-upper], [data-kk-headless-range-upper]');
    var tooltipLower = slider.querySelector('[data-kk-range-tooltip="lower"]');
    var tooltipUpper = slider.querySelector('[data-kk-range-tooltip="upper"]');

    function update(input, tooltip) {
      if (!input || !tooltip) return;
      var inputMin = toNumber(input.min, 0);
      var inputMax = toNumber(input.max, 100);
      var value = toNumber(input.value, inputMin);
      var range = inputMax - inputMin;
      var percent = range > 0 ? ((value - inputMin) / range * 100) : 0;
      var thumbHalf = 13;
      var offset = thumbHalf * (1 - percent / 50);
      tooltip.style.left = 'calc(' + percent + '% + ' + offset.toFixed(2) + 'px)';
      tooltip.textContent = prefix ? prefix + value : String(value);
    }

    update(lower, tooltipLower);
    update(upper, tooltipUpper);
  }

  function updateAllRangeTooltips(state) {
    if (!state || !state.root) return;
    state.root.querySelectorAll('[data-kk-headless-price-range], [data-kk-headless-native-range]').forEach(updateRangeTooltips);
    var modalContent = document.querySelector('[data-modal-container] [data-modal-content]');
    if (modalContent) {
      modalContent.querySelectorAll('[data-kk-headless-price-range], [data-kk-headless-native-range]').forEach(updateRangeTooltips);
    }
  }

  function applyHeadlessRange(range, source) {
    var state = getState(range);
    var minInput = range.querySelector('[data-kk-headless-range-min-input]');
    var maxInput = range.querySelector('[data-kk-headless-range-max-input]');
    var lower = range.querySelector('[data-kk-headless-range-lower]');
    var upper = range.querySelector('[data-kk-headless-range-upper]');
    var min = toNumber(range.getAttribute('data-kk-headless-range-min'), 0);
    var max = toNumber(range.getAttribute('data-kk-headless-range-max'), 0);
    var activeMin;
    var activeMax;

    if (!state) {
      return;
    }

    if (source === lower || source === minInput) {
      activeMin = toNumber(source.value, min);
      activeMax = toNumber((maxInput && maxInput.value) || (upper && upper.value), max);
    } else if (source === upper || source === maxInput) {
      activeMin = toNumber((minInput && minInput.value) || (lower && lower.value), min);
      activeMax = toNumber(source.value, max);
    } else {
      activeMin = toNumber(minInput && minInput.value, min);
      activeMax = toNumber(maxInput && maxInput.value, max);
    }

    activeMin = Math.max(min, Math.min(activeMin, max));
    activeMax = Math.min(max, Math.max(activeMax, activeMin));

    if (minInput) minInput.value = activeMin;
    if (maxInput) maxInput.value = activeMax;
    if (lower) lower.value = activeMin;
    if (upper) upper.value = activeMax;

    range.querySelectorAll('[data-kk-headless-range-option]').forEach(function (option) {
      var parsed = parseFilterInput(option.value);
      var key = stableFilterKey(parsed);
      var value = toNumber(option.getAttribute('data-kk-headless-range-value'), 0);

      state.selected.delete(key);

      if (value >= activeMin && value <= activeMax && !(activeMin === min && activeMax === max)) {
        state.selected.set(key, {
          input: parsed,
          label: option.getAttribute('data-kk-headless-range-label') || '',
          filterLabel: option.getAttribute('data-kk-headless-filter-label') || ''
        });
      }
    });

    updateRangeTooltips(range);
  }

  function applyPriceRange(range, source) {
    var state = getState(range);
    var minInput = range.querySelector('[data-kk-headless-price-min]');
    var maxInput = range.querySelector('[data-kk-headless-price-max]');
    var lower = range.querySelector('[data-kk-headless-price-lower]');
    var upper = range.querySelector('[data-kk-headless-price-upper]');
    var min = toNumber(range.getAttribute('data-kk-headless-range-min'), state ? state.priceBoundMin : 0);
    var max = toNumber(range.getAttribute('data-kk-headless-range-max'), state ? state.priceBoundMax : 0);
    var minValue;
    var maxValue;

    if (!state) {
      return;
    }

    if (source === lower || source === minInput) {
      minValue = toNumber(source.value, min);
      maxValue = toNumber((maxInput && maxInput.value) || (upper && upper.value), max);
    } else if (source === upper || source === maxInput) {
      minValue = toNumber((minInput && minInput.value) || (lower && lower.value), min);
      maxValue = toNumber(source.value, max);
    } else {
      minValue = toNumber(minInput && minInput.value, min);
      maxValue = toNumber(maxInput && maxInput.value, max);
    }

    minValue = Math.max(min, Math.min(minValue, max));
    maxValue = Math.min(max, Math.max(maxValue, minValue));

    if (minInput) minInput.value = minValue;
    if (maxInput) maxInput.value = maxValue;
    if (lower) lower.value = Math.floor(minValue);
    if (upper) upper.value = Math.ceil(maxValue);

    state.priceMin = minValue <= min ? null : minValue;
    state.priceMax = maxValue >= max ? null : maxValue;

    updateRangeTooltips(range);
  }

  function isMobileFilterModal(target) {
    return Boolean(target && target.closest && target.closest('.modal--productgrid-filters'));
  }

  function queueApply(state, target) {
    if (isMobileFilterModal(target)) {
      state.modalDirty = true;
      renderActiveFilters(state);
      updateFilterTrigger(state);

      window.clearTimeout(state.modalRefreshTimer);
      state.modalRefreshTimer = window.setTimeout(function () {
        buildFilters(state);
        renderFilters(state);
      }, 200);
      return;
    }

    state.visibleCount = state.perPage;
    applyCollection(state);
  }

  function getState(element) {
    var root = element && element.closest ? element.closest('[data-kk-headless-collection]') : null;

    if (root) {
      return states.get(root);
    }

    if (element && element.closest && element.closest('.modal--productgrid-filters')) {
      return activeState;
    }

    return null;
  }

  function handleInputChange(event) {
    var target = event.target;
    var state;
    var range;

    if (!target || !target.closest) {
      return;
    }

    state = getState(target);

    if (!state) {
      return;
    }

    if (target.matches('[data-kk-headless-filter-input]')) {
      var filterItem = target.closest('.kk-facet__item');
      if (filterItem) {
        filterItem.classList.toggle('filter-item--active', target.checked);
        filterItem.classList.toggle('filter-item--inactive', !target.checked);
      }
      updateSelectedFromInput(state, target);
      queueApply(state, target);
      return;
    }

    range = target.closest('[data-kk-headless-native-range]');
    if (range) {
      applyHeadlessRange(range, target);
      queueApply(state, target);
      return;
    }

    range = target.closest('[data-kk-headless-price-range]');
    if (range) {
      applyPriceRange(range, target);
      queueApply(state, target);
    }
  }

  function handleClick(event) {
    var target = event.target;
    var state;
    var key;
    var toggle;
    var list;
    var hidden;

    if (!target || !target.closest) {
      return;
    }

    state = getState(target);
    if (!state) {
      return;
    }

    if (target.closest('[data-productgrid-trigger-filters]')) {
      var sidebarWrapper = state.root.querySelector('[data-kk-headless-filters-content]');
      if (sidebarWrapper && sidebarWrapper.children.length === 0 && state.indexLoaded) {
        buildFilters(state);
        renderFilters(state);
      }
      return;
    }

    if (target.closest('[data-kk-headless-load-more]')) {
      event.preventDefault();
      state.visibleCount += state.perPage;
      renderProducts(state, state.resultProducts.slice(0, state.visibleCount));
      return;
    }

    if (target.closest('[data-kk-headless-filter-results]')) {
      if (state.modalDirty) {
        state.modalDirty = false;
        state.visibleCount = state.perPage;
        applyCollection(state);
      }
      return;
    }

    if (target.closest('.modal--productgrid-filters [data-modal-close]')) {
      if (state.modalDirty) {
        state.modalDirty = false;
        state.visibleCount = state.perPage;
        applyCollection(state);
      }
      return;
    }

    if (target.closest('[data-kk-headless-clear-all]')) {
      event.preventDefault();
      state.selected.clear();
      state.priceMin = null;
      state.priceMax = null;
      state.visibleCount = state.perPage;
      applyCollection(state);
      return;
    }

    if (target.closest('[data-kk-headless-remove-price]')) {
      event.preventDefault();
      state.priceMin = null;
      state.priceMax = null;
      state.visibleCount = state.perPage;
      applyCollection(state);
      return;
    }

    if (target.closest('[data-kk-headless-remove-filter]')) {
      event.preventDefault();
      key = target.closest('[data-kk-headless-remove-filter]').getAttribute('data-kk-headless-remove-filter');
      state.selected.delete(key);
      state.visibleCount = state.perPage;
      applyCollection(state);
      return;
    }

    if (target.closest('[data-kk-headless-remove-range-facet]')) {
      event.preventDefault();
      var facetKey = target.closest('[data-kk-headless-remove-range-facet]').getAttribute('data-kk-headless-remove-range-facet');
      var keysToRemove = [];
      state.selected.forEach(function (item, itemKey) {
        if (inputFacetKey(item.input) === facetKey) {
          keysToRemove.push(itemKey);
        }
      });
      keysToRemove.forEach(function (k) { state.selected.delete(k); });
      state.visibleCount = state.perPage;
      applyCollection(state);
      return;
    }

    toggle = target.closest('[data-kk-headless-toggle-more]');
    if (toggle) {
      event.preventDefault();
      list = toggle.closest('[data-kk-headless-filter-list]');
      hidden = toggle.getAttribute('data-kk-headless-toggle-more') !== 'true';
      if (list) {
        list.querySelectorAll('[data-hidden-default]').forEach(function (item) {
          item.classList.toggle('filter-item--hidden', !hidden);
        });
        list.classList.toggle('kk-facet__list--expanded', hidden);
      }
      toggle.setAttribute('data-kk-headless-toggle-more', hidden ? 'true' : 'false');
      toggle.textContent = hidden
        ? (toggle.getAttribute('data-kk-headless-see-less-text') || t('see_less', 'See less'))
        : (toggle.getAttribute('data-kk-headless-see-more-text') || t('see_more', 'See more'));
    }
  }

  function handleFilterSearch(event) {
    var input = event.target;
    var list;
    var term;
    var expanded;
    var toggle;

    if (!input || !input.matches || !input.matches('[data-kk-headless-filter-search]')) {
      return;
    }

    list = input.closest('[data-kk-headless-facet]').querySelector('[data-kk-headless-filter-list]');
    term = input.value.trim().toLowerCase();

    if (!list) {
      return;
    }

    toggle = list.querySelector('[data-kk-headless-toggle-more]');
    expanded = toggle && toggle.getAttribute('data-kk-headless-toggle-more') === 'true';
    list.classList.toggle('kk-facet__list--expanded', Boolean(term) || Boolean(expanded));

    list.querySelectorAll('[data-kk-headless-filter-option]').forEach(function (item) {
      var text = (item.getAttribute('data-kk-headless-filter-search-text') || item.textContent || '').toLowerCase();
      var matches = !term || text.indexOf(term) !== -1;

      item.hidden = !matches;
      item.classList.toggle('kk-filter-option--search-hidden', !matches);

      if (term) {
        item.classList.toggle('filter-item--hidden', !matches);
      } else if (item.hasAttribute('data-hidden-default')) {
        item.classList.toggle('filter-item--hidden', !expanded);
      } else {
        item.classList.remove('filter-item--hidden');
      }
    });

    if (toggle) {
      var toggleItem = toggle.closest('.filter-item');

      if (toggleItem) {
        toggleItem.hidden = !!term;
        toggleItem.classList.toggle('kk-filter-option--search-hidden', !!term);
      }
    }
  }

  function queueSearch(state) {
    window.clearTimeout(state.searchTimer);
    state.searchTimer = window.setTimeout(function () {
      state.visibleCount = state.perPage;
      applyCollection(state);
    }, 550);
  }

  function initSearch(state) {
    var root = state.root.querySelector('[data-kk-collection-search]');
    var input = root && root.querySelector('[data-kk-collection-search-input]');
    var submit = root && root.querySelector('[data-kk-collection-search-submit]');
    var clear = root && root.querySelector('[data-kk-collection-search-clear]');

    if (!root || !input) {
      return;
    }

    input.value = state.query;
    root.dataset.kkHeadlessCollectionSearchReady = 'true';

    input.addEventListener('input', function () {
      state.query = input.value.trim();
      if (clear) clear.hidden = !state.query;
      queueSearch(state);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        window.clearTimeout(state.searchTimer);
        state.query = input.value.trim();
        state.visibleCount = state.perPage;
        applyCollection(state);
      }
    });

    if (submit) {
      submit.addEventListener('click', function () {
        window.clearTimeout(state.searchTimer);
        state.query = input.value.trim();
        state.visibleCount = state.perPage;
        applyCollection(state);
      });
    }

    if (clear) {
      clear.hidden = !state.query;
      clear.addEventListener('click', function () {
        input.value = '';
        state.query = '';
        state.visibleCount = state.perPage;
        clear.hidden = true;
        applyCollection(state);
      });
    }
  }

  function initSort(state) {
    var sort = state.root.querySelector('[data-productgrid-trigger-sort]');
    var sortButtons = Array.prototype.slice.call(document.querySelectorAll('[data-productgrid-trigger-sort-button]'));

    function syncSortControls() {
      var selectedOption;
      var measure;

      if (sort) {
        sort.value = state.sortBy || sort.value || '';
        selectedOption = sort.options && sort.selectedIndex >= 0 ? sort.options[sort.selectedIndex] : null;
        measure = state.root.querySelector('[data-kk-sortby-measure]');

        if (measure && selectedOption) {
          measure.textContent = selectedOption.textContent.trim();
        }
      }

      sortButtons.forEach(function (button) {
        var active = button.value === state.sortBy;

        button.disabled = active;
        button.classList.toggle('utils-sortby--modal-button--active', active);
      });
    }

    function applySort(value) {
      if (!value || state.sortBy === value) {
        syncSortControls();
        return;
      }

      state.sortBy = value;
      state.visibleCount = state.perPage;
      syncSortControls();
      applyCollection(state);
    }

    if (!sort) {
      return;
    }

    state.sortBy = state.sortBy || sort.value || '';
    syncSortControls();

    sort.addEventListener('change', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      applySort(sort.value);
    }, true);

    sortButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        applySort(button.value);
      }, true);
    });
  }

  function initRoot(root) {
    var state;
    var shouldRender;

    if (states.has(root)) {
      return;
    }

    state = {
      root: root,
      handle: root.getAttribute('data-kk-collection-handle') || '',
      collectionCount: parseInt(root.getAttribute('data-kk-collection-count'), 10) || 0,
      perPage: Math.min(250, Math.max(1, parseInt(root.getAttribute('data-kk-products-per-page'), 10) || 24)),
      tagLimit: 7,
      showProductCounts: root.getAttribute('data-kk-show-product-counts') === 'true',
      selected: new Map(),
      filters: [],
      priceMin: null,
      priceMax: null,
      priceBoundMax: 0,
      currencyCode: config.currencyCode || 'EUR',
      query: '',
      sortBy: '',
      loadedCount: 0,
      visibleCount: 0,
      resultProducts: [],
      indexProducts: [],
      indexLoaded: false,
      indexPromise: null,
      indexSortBy: '',
      indexGeneration: 0,
      partialRendered: false,
      modalDirty: false,
      searchTimer: null
    };

    states.set(root, state);
    activeState = state;
    window.KKHeadlessDebug = state;
    readUrlState(state);
    initSearch(state);
    initSort(state);
    watchSidebar(state);

    state.visibleCount = state.perPage;
    shouldRender = Boolean(state.query || state.selected.size || state.priceMin !== null || state.priceMax !== null);
    applyCollection(state, { render: shouldRender });
  }

  function initAll() {
    document.querySelectorAll('[data-kk-headless-collection]').forEach(initRoot);
  }

  document.addEventListener('change', handleInputChange, true);
  document.addEventListener('input', function (event) {
    handleFilterSearch(event);

    var target = event.target;
    if (!target || !target.closest) return;
    var range = target.closest('[data-kk-headless-price-range], [data-kk-headless-native-range]');
    if (range) {
      updateRangeTooltips(range);
    }
  }, true);
  document.addEventListener('click', handleClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
}());
